// массив для корректного вывода окончания у таймера
var daysArray = ['дни', 'дня', 'дней', 'день'];
var upTimerInterval, downTimerInterval;

// убывающий таймер
function downTimer(endtime, currentTime) {
    var timer = $('.test-timer_end');

    timer.removeClass('hidden');

    function updateClock() {
        currentTime = currentTime + 1000;
        var time = endtime - currentTime;
        var t = getFormatTime(time);
        setTimer(t, timer);
    }

    updateClock();
    downTimerInterval = setInterval(updateClock, 1000);
}

// таймер до окончания теста
var testDeadline = Date.parse($('.test-timer_end').data('end-time')),
    currentTime = Date.parse($('.test-timer_end').data('current-time')); // in ms

downTimer(testDeadline, currentTime);


// возрастающий таймер
function upTimer(startTime, currentTime) {
    var parseCurrentTime = Date.parse(currentTime),
        parseStartTime = Date.parse(startTime),
        time,
        i = 0,
        timer = $('.test-timer_long');

    function updateTimer() {
        if (parseCurrentTime === parseStartTime) {
            time = parseStartTime;
        }
        else if (parseCurrentTime > parseStartTime){
            time = parseCurrentTime - parseStartTime;
        }
        i = i + 1000;
        time = time + i;
        var t = getFormatTime(time);

        setTimer(t, timer);
    }

    updateTimer();
    upTimerInterval = setInterval(updateTimer, 1000);
}

// секундомер для теста
var startTime = $('.test-timer_long').data('start-time'),
    currentTime = $('.test-timer_long').data('current-time');

upTimer(startTime, currentTime);

// получить время в отдельных форматах - дни, часы, минуты, секунды
function getFormatTime(time) {
    var seconds = Math.floor((time / 1000) % 60),
        minutes = Math.floor((time / 1000 / 60) % 60),
        hours = Math.floor((time / (1000 * 60 * 60)) % 24),
        days = Math.floor(time / (1000 * 60 * 60 * 24));
    return {
        'total': time,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
    };
}

// установить значения таймера
function setTimer(t, timerElement) {
    var daysSpan = timerElement.find('.days'),
        hoursSpan = timerElement.find('.hours'),
        minutesSpan = timerElement.find('.minutes'),
        secondsSpan = timerElement.find('.seconds');

    if (t.days <= 0){
        daysSpan.addClass('hidden');
    }
    else {
        daysSpan.text(t.days + ' ' + setWordEnding(t.days, daysArray));
    }
    hoursSpan.text(('0' + t.hours).slice(-2));
    minutesSpan.text(('0' + t.minutes).slice(-2));
    secondsSpan.text(('0' + t.seconds).slice(-2));

    if (t.total <= 0) {
        hoursSpan.text('00');
        minutesSpan.text('00');
        secondsSpan.text('00');
        clearInterval(downTimerInterval);
        clearInterval(upTimerInterval);
    }
}

// обратый таймер
var idBackTimer;
function backTimer() {
    var time = $('.back-timer').data('start-timer');

    $('.user-pop-up__resend-code-btn').addClass('hidden');
    $('.pop-up__timer').text(time + ' сек.');
    $('.user-pop-up__resend-code-timer').removeClass('hidden');

    idBackTimer = setInterval(function () {
        $('.back-timer').text(time + ' сек.');
        if (time == 0) {
            clearInterval(idBackTimer);
            $('.user-pop-up__resend-code-btn').removeClass('hidden');
            $('.user-pop-up__resend-code-timer').addClass('hidden');
        }
        time = time - 1;
    }, 1000);
}

// Выводит правильное окончание
function setWordEnding(number, titles) {
    var cases = [2, 0, 1, 1, 1, 2];

    return titles[(number % 100 == 1) ? 3 : (number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
}
